
















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GRoundedButton',
  props: {
    imageUrl: String as PropType<string>,
  },
  methods: {
    onClick(): void {
      this.$emit('click');
    },
  },
});
